import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { useStyles } from '../adminStyles';
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,Checkbox, FormControlLabel
} from '@material-ui/core';
import { Autocomplete,createFilterOptions } from '@material-ui/lab';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import NotesDialogue from './components/NotesDialogue';
import {
  fetchSummaryReports,
  fetchAllActiveProjects,
  fetchSummaryReportsCsv,
} from '../../../redux/timesheets/timesheetsActions';
import {
  getAppUserList,
  deleteUser,
  clearAppUser,
  getManagersUsers,
} from '../../../redux/appUsers/appUserActions';
import {
  DB_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  EMPLOYEE_TYPE,
} from '../../../redux/constants';

import ExcelExport from './components/ExportExcel';
import SummaryTable from './components/SummaryTable';
const columns = [
  { id: 'isChecked', label: 'All', align: 'center' },
  { id: 'empId', label: 'Emp. Id', align: 'center' },
  { id: 'userName', label: 'Name', align: 'center' },
  { id: 'emailId', label: 'Email', align: 'center' },
  { id: 'regularHrs', label: 'Regular', align: 'center' },
  { id: 'holidayHrs', label: 'Holiday', align: 'center' },
  { id: 'vacationHrs', label: 'Vacation', align: 'center' },
  { id: 'sickHrs', label: 'Sick', align: 'center' },
  { id: 'bereavementHrs', label: 'Bereavement', align: 'center' },
  { id: 'totalHrs', label: 'Total Hours', align: 'center' },
  { id: 'details', label: 'Notes', align: 'center' },
];

const TimesheetSummary = () => {
  document.title = 'Sciata Summaries';
  const {
    approveBtn,
    gridElRight,
    inputMobile,
    btnMobile2,
  } = useStyles();

  const dispatch = useDispatch();
  const users = useSelector(state => state.timesheets.all);
  const activeProjects = useSelector(state => state.timesheets.activeProjects);

  const [orderAscending, setOrderAscending] = useState(true);
  const timeSheetUsersList = useSelector(state => state.appUsers.usersList || []);
  const [asc, setAsc] = useState('desc');
  const [searchTerm, setSearchTerm] = useState('');
  const [rows, setRows] = useState([]);
  const [state, setState] = useState([]);
  const [selectedUser, setselectedUser] = useState("");
  const [notesObj, setNotesObj] = useState([]);
  const [fromDate, setFromDate] = useState(moment().format(DB_DATE_FORMAT));
  const [toDate, setToDate] = useState(moment().format(DB_DATE_FORMAT));
  const [project, setProject] = useState({ name: '', code: 0 });
  const [render, setRender] = useState(false);
  const [openToDate, setOpenToDate] = useState(false);
  const [includesTask, setIncludesTask] = useState(false);
  const [empType, setEmpType] = useState('ALL');
  const [detailOpen, setDetailOpen] = useState(false); 
  const handleDetailClose = () => setDetailOpen(false);
  const [record, setRecord] = useState(0);
  //const bindUsers = () => dispatch(getAppUserList());
  const renderManagerList = () => {
    let managers = timeSheetUsersList.filter(user => user.role === 'manager') || [];

    return managers.map(manager => (
      <MenuItem value={manager.id}>{`${manager.firstName} ${manager.lastName}`}</MenuItem>
    ));
  };

  useEffect(() => {
    dispatch(
      fetchSummaryReports({
        fromDate: fromDate,
        toDate: toDate,
        projectCode: pId,
        includesTasks:includesTask,
        byManager:record

      })
    );
    dispatch(fetchAllActiveProjects({}))
    dispatch(getAppUserList())
  }, []);

  const rowData = {
    timesheets: [],
  };
  useEffect(() => {
    setTimeout(() => {
      setRender(true);
    }, 500);
  }, []);

  const handleDetailOpen = (userObject,userName) => {
    setDetailOpen(true);
    setNotesObj(userObject);
    setselectedUser(userName);
  };

  const handleGo = () => {
    dispatch(
      fetchSummaryReports({
        fromDate: moment(fromDate).format('MM-DD-YYYY'),
        toDate: moment(toDate).format('MM-DD-YYYY'), projectCode: pId,
        includesTasks:includesTask,
        byManager:record
      })
    );
    setAllRecord(false);
    setRecStatus(false);
  };
  useEffect(() => {
    users &&
      Array.isArray(users) &&
      users.forEach(user => {
        rowData.timesheets.push({
          isChecked: false,
          details:user.tasks||[],
          emailId: user.emailId,
          userName: user.userName,
          empType: user.empType,
          empId: user.empId,
          sickHrs: user.sickHrs,
          vacationHrs: user.vacationHrs,
          holidayHrs: user.holidayHrs,
          regularHrs: user.regularHrs,
          bereavementHrs:user.bereavementHrs,
          totalHrs: user.totalHrs,
          note:""
        });
      });
    setRows(rowData.timesheets || []);
  }, [users]);

  const setTheSearchTerm = e => {
    setSearchTerm(e.target.value);
  };
const setIncludesTasks=e=>{
  setIncludesTask(e.target.checked)
}

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: option => (option.projectName+" "+option.client),
  });

  const exportCsv = async (start, end, type) => {
    await dispatch(
      fetchSummaryReportsCsv({
        fromDate: start,
        toDate: end,
        empType: type,
      })
    );
    // setAllRecord(false);
    // setRecStatus(false);
  };

  const sortArray = (arr, property) => () => {
    let array = [...arr];
    setOrderAscending(!orderAscending);
    orderAscending ? setAsc('asc') : setAsc('desc');

    if (typeof property === 'string') {
      setRows(
        array.sort((a, b) => {
          let nameA = (a.userName || '').toString().toUpperCase();
          let nameB = (b.userName || '').toString().toUpperCase();

          if (orderAscending) {
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          }
          if (!orderAscending) {
            if (nameB < nameA) {
              return -1;
            }
            if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
        })
      );
    }

    property && orderAscending
      ? setRows(array.sort((a, b) => a[property] - b[property]))
      : setRows(array.sort((a, b) => b[property] - a[property]));

    property && !orderAscending
      ? setRows(array.sort((a, b) => b[property] - a[property]))
      : setRows(array.sort((a, b) => a[property] - b[property]));
    return array;
  };

  const selectAll = (rows,e)  => {
    let array = [...rows];
    array.forEach((user,index) => {
      if(empType=="ALL"||array[index].empType==empType)
      array[index].isChecked=e.target.checked
    });
    setRows(array);
    handleCheck();
    setAllRecord(e.target.checked);
  };
  const onFieldChange = e => {
    setRecord(parseInt(e.target.value||0));
  };
  const selectByIndex = (rows, e,index) => {
    let array = [...rows];
    array[index].isChecked = e.target.checked
    setRows(array);
    handleCheck();
    setAllRecord(false);
  };

  const setDate = (e, key) => {
    setState({ [key]: moment(e) });
  };

  const handleCheck = () => {
     setRecStatus((rows||[]).some(item => item.isChecked === true));
  }
  const [pId, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState('');
  const [isRecSelected, setRecStatus] = React.useState(false);
  const [allRecord, setAllRecord] = React.useState(false);

  const summaryTableProps = {
    columns,
    rows,
    sortArray,
    selectAll,
    selectByIndex,
    handleDetailOpen,
    orderAscending,
    isRecSelected,
    asc,
    searchTerm,
    allRecord,
    employeeType: empType,
  };
  const taskNotesProps = {
    notesObj,
    detailOpen,
    handleDetailClose,
    selectedUser
  };
  return (
    <>
      <h1>Summaries</h1>
      <Grid container justify='center' alignItems='center' spacing={1}>
        <Grid item container xs={12} md={2} justify='start'>
          <TextField
            type='search'
            label='Search'
            className={inputMobile}
            variant='outlined'
            value={searchTerm}
            onChange={setTheSearchTerm}
          />
        </Grid>
        <Grid item container xs={12} md={2} justify='start'>
      <Autocomplete
        onChange={(event, newValue) => {
          setValue(newValue==null?"":newValue.projectId);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        filterOptions={filterOptions}
        id="controllable-states-demo"
        getOptionLabel={(option) => (option.client||"")==""?(option.projectName||""):(option.projectName||"")+"["+(option.client||"")+"]"}
        options={activeProjects}
        style={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Project/Client" variant="outlined" />}
      />
        </Grid>
        <Grid item xs={12} md={2}>
                  <FormControl  fullWidth>
                    <InputLabel variant='outlined' id='select-label-managerId'>
                      Manager*
                    </InputLabel>
                    <Select
                      labelId='select-label-managerId'
                      label='Manager*'
                      name='managerId'
                      variant='outlined'
                      value={record}
                      id='manager'
                      onChange={onFieldChange}
                     // disabled={record.role === 'manager' || record.role === ''}
                    >{<MenuItem value={0}>{"Select Manager"}</MenuItem>}
                      {renderManagerList()}
                    </Select>
                  </FormControl>
                </Grid>
      
        <Grid container item xs={12} md={6} spacing={1}>
          <Grid item md={4}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant='inline'
                inputVariant='outlined'
                className={inputMobile}
                format={DISPLAY_DATE_FORMAT.replace('DD', 'dd').replace('YYYY', 'yyyy')}
                id='date-picker-inline'
                label='From Date'
                value={moment(fromDate, DB_DATE_FORMAT)}
                autoOk={true}
                onChange={date => {
                  setOpenToDate(true);
                  setFromDate(date);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item md={4}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant='inline'
                inputVariant='outlined'
                className={inputMobile}
                format={DISPLAY_DATE_FORMAT.replace('DD', 'dd').replace('YYYY', 'yyyy')}
                id='date-picker-inline'
                open={openToDate}
                label='To Date'
                value={moment(toDate, DB_DATE_FORMAT)}
                autoOk={true}
                onChange={date => {
                  setOpenToDate(false);
                  setToDate(date);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          
        
        </Grid>
        <Grid container item xs={12} md={8} className={"gridElRight"}>
        <Grid item xs={12} md={2}>
            <FormControl fullWidth variant='outlined' className={inputMobile}>
              <InputLabel id='label'>Type</InputLabel>
              <Select
                labelId='label'
                id='demo-simple-select-outlined'
                label='Type'
                value={empType}
                onChange={e => {
                  setEmpType(e.target.value);
                  setAllRecord(false);
                  rows.forEach((row,index) => {
                    if ((e.target.value == "ALL") || (!(rows[index].empType == e.target.value))){
                      rows[index].isChecked = false

                    }
                  });
                  setRows(rows);
                }}
              >
                <MenuItem value='ALL'>All</MenuItem>
                {Object.keys(EMPLOYEE_TYPE).map(item => {
                  return <MenuItem value={EMPLOYEE_TYPE[item]}>{item}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControlLabel
              control={<Checkbox checked={includesTask} name="includesTask" onChange={setIncludesTasks}/>}
              label="Include task details"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              className={btnMobile2}
              onClick={() => {
                exportCsv(
                  moment(fromDate).format('MM-DD-YYYY'),
                  moment(toDate).format('MM-DD-YYYY'),
                  empType === 'ALL' ? '' : empType
                );
              }}
            >
              Summ. By Category
            </Button>
          </Grid>
          <Grid item xs={12} md={3}>
            <ExcelExport  approveBtn={approveBtn} {...summaryTableProps} />
          </Grid>
          <Grid item xs={12} md={1}>
            <Button className={btnMobile2} onClick={handleGo} variant='contained'>
              GO
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <SummaryTable {...summaryTableProps} />
      <NotesDialogue {...taskNotesProps} />
    </>
  );
};

export default TimesheetSummary;
